define('app/sds/service/type/sds-service-type',[],function(){
	return {
		restrict: "A",
		scope: false,
		template: null,
		controller: {
			bind: {
				"serviceTypeCode": "=sdsServiceType"
			}
		}
	};
});
